import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import LandingPage from "@/pages/LandingPage";
import LibraryPage from "@/pages/LibraryPage";
import ReaderPage from "@/pages/ReaderPage";
import AuthorPage from "@/pages/AuthorPage";

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-[#F9F9F8]">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Navbar />
                <LandingPage />
                <Footer />
              </>
            }
          />
          <Route
            path="/library"
            element={
              <>
                <Navbar />
                <LibraryPage />
                <Footer />
              </>
            }
          />
          <Route path="/read/:ebookId" element={<ReaderPage />} />
          <Route path="/read/:ebookId/:chapterId" element={<ReaderPage />} />
          <Route
            path="/author"
            element={
              <>
                <Navbar />
                <AuthorPage />
                <Footer />
              </>
            }
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
